import { render } from "./ModalWhyEmail.vue?vue&type=template&id=dd67fcc8"
import script from "./ModalWhyEmail.vue?vue&type=script&lang=js"
export * from "./ModalWhyEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__